import React from 'react'
import { Link } from 'gatsby'
import icon1 from '../../assets/images/services/service-icon1.png'
import icon2 from '../../assets/images/services/service-icon2.png'
import icon3 from '../../assets/images/services/service-icon3.png'
import {useTranslation} from "gatsby-plugin-react-i18next";

const COOPb = () => {
    const {t} = useTranslation();

    return (
        <section className="services-area pt-100 pb-70 bg-f1f8fb">
            <div className="container">
                <div className="section-title">
                    <h2>{t('home.COOPbh2')}</h2>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-box ">
                            <div className="icon">
                                <img src={icon1} alt="about" />
                            </div>
                            <h3>
                                <Link to="/contact-direct">
                                    {t('home.COOPbi1')}
                                </Link>
                            </h3>
                            <p>{t('home.COOPbp1')}</p>

                            <Link to="/contact-direct" className="read-more-btn">
                                {t('EnSavoirPlus')} <i className="flaticon-right"></i>
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-box">
                            <div className="icon">
                                <img src={icon2} alt="about" />
                            </div>
                            <h3>
                                <Link to="/contact-direct">
                                    {t('home.COOPbi2')}
                                </Link>
                            </h3>
                            <p>{t('home.COOPbp2')}</p>
                            
                            <Link to="/contact-direct" className="read-more-btn">
                                {t('EnSavoirPlus')} <i className="flaticon-right"></i>
                            </Link>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-box">
                            <div className="icon">
                                <img src={icon3} alt="about" />
                            </div>
                            <h3>
                                <Link to="/contact-direct">
                                    {t('home.COOPbi3')}
                                </Link>
                            </h3>
                            <p>{t('home.COOPbp3')}</p>
                            
                            <Link to="/contact-direct" className="read-more-btn">
                                {t('EnSavoirPlus')} <i className="flaticon-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default COOPb